import { SIZES } from "./actionPanel.styled";
export { default } from "./actionPanelContainer";
const PANEL_HEIGHT = SIZES.TAB_HEIGHT + SIZES.NAVIGATION_PANEL_HEIGHT;
export { PANEL_HEIGHT };
